import { Component, Inject, Input, OnInit, OnDestroy } from '@angular/core';
import {
    DeliveringTaskListItem,
    DeliveryTaskState,
    ITasksService,
    TASKS_SERVICE_IMPL,
    ColorClass,
    SumUpFinalize,
    CashOnDeliveryFinalize,
    PaymentType,
    LatLng,
    GEOLOCATION_SERVICE_IMPL,
    IGeolocationService,
    AppSettings,
    ModalService,
    priceRound,
    CashOnDeliveryAdministration,
} from 'shared';
import { MyTasksService } from 'dm-src/app/modules/my-tasks/my-tasks.service';
import { FlashMessage } from 'dm-src/dtos/flash-message';
import { IosAndAndroidNatvieFunctionsService } from 'dm-src/services/ios-and-android-natvie-functions/ios-and-android-natvie-functions.service';
import { SumUpCallbackModel, SumupService } from 'dm-src/services/sumup/sumup.service';
import { IsWrappingService } from 'dm-src/services/is-wrapping/is-wrapping.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil, take, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Subscription, timer } from 'rxjs';
import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';

@Component({
    selector: 'app-delivering-task-button',
    templateUrl: './delivering-task-buttons.component.html',
    styleUrls: ['./delivering-task-buttons.component.scss'],
})
export class DeliveringTaskButtonsComponent implements OnInit, OnDestroy {
    @Input() task: DeliveringTaskListItem;

    public DeliveryTaskState = DeliveryTaskState;
    public PaymentType = PaymentType;

    private sumUpFinalize: SumUpFinalize;
    private cashOnDeliveryFinalize: CashOnDeliveryFinalize;

    public isPaidOnDelivery?: boolean;
    public paymentButtonNeeded: boolean;
    public isDeliveryDoneInProgress = false;

    public myObservable: any;
    public myObservableData: any;

    private sumUpEndStatuses: string[] = ['SUCCESSFUL', 'FAILED'];
    public timerSubscription!: Subscription;
    public sumupPaymentbecameSuccess = false;

    private interval: NodeJS.Timeout;

    private componentDestroyed$: Subject<boolean> = new Subject();

    public paymentStatus = '';
    public detroyedComponent = '';
    public isButtonBlocked = false;

    lastLatLonData = new LatLng(0, 0);
    private uniqTransactionIdWithTaskId = '';
    public countryCode = location.origin.includes('.at') ? 'at' : 'hu';

    /******** CASH ON DELIVERY BLOCK ********/
    public cashPaymentForm: UntypedFormGroup;
    ColorClass = ColorClass;

    // KEREKÍTETLEN beszedendő (kijelzett)
    deliveryScreenTotalPriceUnrounded: number;

    // Kerekítési különbözet (-2..2) csak készpénznél
    roundingDifference: number = 0;

    // Készpénzben fizetendő (unrounded + roundingDifference)
    cashPayableTotal: number = 0;

    public get fields(): any {
        return this.cashPaymentForm.controls;
    }
    /******** CASH ON DELIVERY BLOCK END ********/

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _translateService: TranslateService,
        @Inject(TASKS_SERVICE_IMPL) private _tasksService: ITasksService,
        @Inject(GEOLOCATION_SERVICE_IMPL)
        private _geolocationService: IGeolocationService,
        private _myTasksService: MyTasksService,
        private snackBar: MatSnackBar,
        private _iosAndAndroidNatvieFunctionsService: IosAndAndroidNatvieFunctionsService,
        private _sumupService: SumupService,
        private isWrapping: IsWrappingService,
        private _modalService: ModalService,
        private translateService: TranslateService,
        public datepipe: DatePipe
    ) {}

    ngOnInit(): void {
        this.checkPayment();

        this.paymentButtonNeeded =
            this.task.paymentType === PaymentType.PayOnDeliveryCard ||
            this.task.paymentType === PaymentType.PayOnDeliveryCash;

        /******** CASH ON DELIVERY INIT ********/

        // 1) Beszedendő összeg: KEREKÍTETLEN (Ft)
        this.deliveryScreenTotalPriceUnrounded = priceRound(
            this.task.customerPaidTotalPrice + this.task.deliveryFee
        );

        // 2) Kerekítési különbözet (csak készpénz)
        this.roundingDifference =
            this.task.paymentType === PaymentType.PayOnDeliveryCash
                ? this.cashRoundingDiffHu(this.deliveryScreenTotalPriceUnrounded)
                : 0;

        // 3) Készpénzben fizetendő összeg
        this.cashPayableTotal = priceRound(
            this.deliveryScreenTotalPriceUnrounded + this.roundingDifference
        );

        this.cashPaymentForm = this._formBuilder.group({
            // Kijelzett beszedendő (kerekítetlen)
            customerPaidTotalPrice: [
                {
                    value: priceRound(this.deliveryScreenTotalPriceUnrounded),
                    disabled: true,
                },
            ],

            // -2..2
            roundingDifference: [{ value: this.roundingDifference, disabled: true }],

            // unrounded + diff
            cashPayableTotal: [
                { value: priceRound(this.cashPayableTotal), disabled: true },
            ],

            // Átvett összeg: minimum a készpénzben fizetendő (itt jön a “2 Ft-tal kevesebb is oké”)
            amountReceivedFromCustomer: [
                null,
                [Validators.required, Validators.min(priceRound(this.cashPayableTotal))],
            ],

            changeDueToCustomer: [{ value: 0, disabled: true }],

            changeGivenToCustomer: [
                null,
                [Validators.required, this.maxChangeValidator()],
            ],
        });

        // Automatikus visszajáró frissítés
        this.cashPaymentForm
            .get('amountReceivedFromCustomer')
            ?.valueChanges.subscribe((val) => {
                const received = priceRound(val ?? 0);
                const payable = priceRound(
                    this.cashPaymentForm.get('cashPayableTotal')?.value ?? 0
                );

                const change = priceRound(received - payable);
                const changeDue = priceRound(change >= 0 ? change : 0);

                this.cashPaymentForm
                    .get('changeDueToCustomer')
                    ?.setValue(changeDue, { emitEvent: false });

                this.cashPaymentForm
                    .get('changeGivenToCustomer')
                    ?.updateValueAndValidity();
            });

        /******** CASH ON DELIVERY INIT END ********/
    }

    public handleCollapse(collapsed: boolean) {
        if (!collapsed) {
            this.paymentButtonNeeded =
                this.task.paymentType === PaymentType.PayOnDeliveryCard ||
                this.task.paymentType === PaymentType.PayOnDeliveryCash;

            if (
                !this.isPaidOnDelivery &&
                this.paymentButtonNeeded &&
                this.task.paymentType === PaymentType.PayOnDeliveryCard
            ) {
                this.genereateUniqId();
                this.checkPayment();
            }
        }
    }

    public sumupSubScribeEvent(_sumUpCallbackModel?: SumUpCallbackModel) {
        this.myObservable = this._sumupService
            .getCallbackResult()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (response: SumUpCallbackModel) => {
                    if (_sumUpCallbackModel) {
                        this.myObservableData = _sumUpCallbackModel;
                    } else {
                        this.myObservableData = response;
                    }

                    if (this.myObservableData != null) {
                        this.sumupFinalization();

                        if (
                            this.myObservableData?.smpStatus.toLocaleLowerCase() !==
                            'success'
                        ) {
                            this.genereateUniqId();
                            this.isPaidOnDelivery = false;

                            this.translateService
                                .get('payment-state.Failed')
                                .pipe(takeUntil(this.componentDestroyed$))
                                .subscribe((text) =>
                                    this._iosAndAndroidNatvieFunctionsService.showToast(
                                        text
                                    )
                                );
                        } else {
                            this.isPaidOnDelivery = true;
                        }

                        this.myObservable.unsubscribe();
                    }
                },
                (error) => {
                    this.myObservable.unsubscribe();
                    console.error(error);
                    this.isButtonBlocked = false;
                    this.ngOnDestroy();
                }
            );
    }

    public acceptDelivering(): void {
        this._tasksService
            .checkIfTheUserIsTheSame(this.task.deliveryTaskID)
            .subscribe((isTheSameUser) => {
                if (isTheSameUser) {
                    this._tasksService
                        .acceptDeliveringTask(this.task.deliveryTaskID)
                        .subscribe((response) => {
                            if (response.status === 200) {
                                this.task.state =
                                    DeliveryTaskState[DeliveryTaskState.ToDo];
                            }
                        });
                } else {
                    this.snackBar.open(
                        this.translateService.instant(
                            'messages.the-user-is-not-the-same'
                        ),
                        null,
                        {
                            verticalPosition: 'top',
                            horizontalPosition: 'center',
                            duration: 10000,
                            panelClass: ['error-snackbar'],
                        }
                    );
                }
            });
    }

    public startDelivering(): void {
        this._tasksService
            .startDeliveringTask(this.task.deliveryTaskID)
            .subscribe((response) => {
                if (response.status === 200) {
                    this.task.state = DeliveryTaskState[DeliveryTaskState.InProgress];
                }
            });
    }

    public setDeliveringDoneWithLatLong(): void {
        let supplierPosition = new LatLng(0, 0);

        if (window.ReactNativeWebView) {
            this._iosAndAndroidNatvieFunctionsService.getCurrentLocation(
                this.task.deliveryTaskID,
                'DeliveringTaskButtonsComponent',
                false
            );

            this._iosAndAndroidNatvieFunctionsService
                .getCurrentPostMessage()
                .subscribe((response) => {
                    if (response.functionName === 'GET_LAT_LON') {
                        this._iosAndAndroidNatvieFunctionsService.currentLatLonData.next(
                            response?.result
                        );
                    }
                });

            this._iosAndAndroidNatvieFunctionsService.currentLatLonData
                .pipe(take(2))
                .subscribe((response) => {
                    if (response?.taskID === this.task.deliveryTaskID) {
                        const latLonData = response.message;
                        this.lastLatLonData = {
                            lat: latLonData?.coords?.latitude,
                            lng: latLonData?.coords?.longitude,
                        };
                        this.handleLocationClosingModal(this.lastLatLonData);
                    }
                });
        } else if (
            this._iosAndAndroidNatvieFunctionsService.osType === 'Android' &&
            this.isWrapping.isWrapping()
        ) {
            const wrapperLastLocationData = JSON.parse(
                this._iosAndAndroidNatvieFunctionsService.getCurrentLocation()
            );

            supplierPosition.lat = wrapperLastLocationData?.lat;
            supplierPosition.lng = wrapperLastLocationData?.lon;

            this.handleLocationClosingModal(supplierPosition);
        } else {
            this._geolocationService
                .getCurrentPosition()
                .subscribe((positionResponse) => {
                    if (positionResponse.coords !== undefined) {
                        supplierPosition = new LatLng(
                            positionResponse.coords.latitude,
                            positionResponse.coords.longitude
                        );
                        this.handleLocationClosingModal(supplierPosition);
                    }
                });
        }
    }

    public handleLocationClosingModal(supplierPosition) {
        this._myTasksService.currentPosition.next(supplierPosition);
        this._modalService.setModalVisibility(true, 'location-check-modal');

        this._myTasksService.isCurrentPositionAccepted
            .pipe(take(1), takeUntil(this.componentDestroyed$))
            .subscribe((isAccepted) => {
                if (isAccepted) {
                    this.setDeliveringDone(supplierPosition);
                }
            });

        this._myTasksService.getLatLongAgain
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((getLatLongAgain) => {
                if (getLatLongAgain) {
                    this._myTasksService.getLatLongAgain.next(false);
                    this.setDeliveringDoneWithLatLong();
                }
            });
    }

    public setDeliveringFailed(): void {
        this._myTasksService.setTaskFailed(this.task.deliveryTaskID);
        this._myTasksService.getMyTasks();
        this.ngOnDestroy();
    }

    public setDeliveringDone(supplierPosition: LatLng): void {
        this.isDeliveryDoneInProgress = true;

        this._tasksService
            .setDeliveringTaskDone(
                this.task.deliveryTaskID,
                this.task.orderID,
                supplierPosition.lat,
                supplierPosition.lng
            )
            .subscribe((response) => {
                if (response.status === 200) {
                    this._myTasksService.removeTask(this.task.deliveryTaskID);

                    const message = new FlashMessage();
                    message.type = ColorClass.Success;
                    message.title = 'Success';
                    message.message = 'Collecting task finished successfully';

                    this._myTasksService.showFlashMessage(message);
                    this._myTasksService.getNextTask();

                    this.isDeliveryDoneInProgress = false;
                    this.ngOnDestroy();
                } else {
                    this.isDeliveryDoneInProgress = false;
                }
            });
    }

    handleSumUpPay(): void {
        if (this.isButtonBlocked) return;

        this.timerSubscription = timer(0, 3000)
            .pipe(switchMap(async () => this.checkPayment()))
            .subscribe((result) => console.log(result));

        this.isButtonBlocked = true;

        this.myObservableData = null;
        this.genereateUniqId();

        this._tasksService
            .createOrderPaymentHistory({
                transaction: 'INPROGRESS',
                request: this.uniqTransactionIdWithTaskId,
                response: this.task.deliveryTaskID,
                amount: this.getTotalPrice(),
            })
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => {
                this._iosAndAndroidNatvieFunctionsService.openSumUp(
                    this.getTotalPrice(),
                    AppSettings.get('currency'),
                    `${this.uniqTransactionIdWithTaskId}`,
                    AppSettings.get('sumUpAffiliateKey'),
                    this.task.orderCode
                );
            });
    }

    openCashAcceptanceModale() {
        this._modalService.setModalVisibility(
            true,
            'app-cash-acceptance-modal' + this.task.deliveryTaskID
        );
    }

    public onPayOnDeliveryCashCloseModal(isCashOnDeliveryAdministrated: boolean = false) {
        if (isCashOnDeliveryAdministrated) {
            this.handleCashOnDeliveryPay();
        }
    }

    handleCashOnDeliveryPay(): void {
        if (this.isButtonBlocked) return;

        this.isButtonBlocked = true;

        this.cashOnDeliveryFinalize = {
            taskID: this.task.deliveryTaskID,
            totalAmountFromPayment: this.getTotalPrice(),
        };

        this._tasksService.cashOnDeliveryFinalize(this.cashOnDeliveryFinalize).subscribe(
            (successful) => {
                if (successful) {
                    this.isPaidOnDelivery = true;
                    this.isButtonBlocked = true;
                } else {
                    this.isPaidOnDelivery = false;
                    this.isButtonBlocked = false;
                }
            },
            (error) => {
                this.isPaidOnDelivery = false;
                this.isButtonBlocked = false;
                console.log(error);
            }
        );
    }

    /**
     * FONTOS:
     * Ez a teljes elszámolt összeg, amit backend felé küldesz (finalize / history),
     * és tartalmazza:
     * - (készpénz esetén) a kerekítési különbözetet
     * - wishlist összeget
     * - “visszajáró különbözetet” (ha kevesebbet adott vissza a futár)
     */
    public getTotalPrice(): number {
        const baseUnrounded = priceRound(
            this.task.customerPaidTotalPrice + this.task.deliveryFee
        );
        const roundingDiff =
            this.task.paymentType === PaymentType.PayOnDeliveryCash
                ? this.cashRoundingDiffHu(baseUnrounded)
                : 0;

        const cashBackDifference = priceRound(
            (this.cashPaymentForm.get('changeDueToCustomer')?.value ?? 0) -
                (this.cashPaymentForm.get('changeGivenToCustomer')?.value ?? 0)
        );

        return priceRound(
            baseUnrounded +
                roundingDiff +
                this.getWishListOrdersSumTotalPrice() +
                cashBackDifference
        );
    }

    public getWishListOrdersSumTotalPrice(): number {
        let wishListOrders = this.task.wishListOrders.filter(
            (x) => x.isCompletedWishListOrder && x.totalPrice && 0 < x.totalPrice
        );

        let sum = 0;

        if (!wishListOrders || wishListOrders.length === 0) {
            return sum;
        }

        wishListOrders.forEach((x) => (sum += x.totalPrice));
        return sum;
    }

    public showPaymentButton(): boolean {
        return (
            !this.isPaidOnDelivery &&
            this.paymentButtonNeeded &&
            this.task.paymentType === PaymentType.PayOnDeliveryCard &&
            this.task.state === DeliveryTaskState[this.DeliveryTaskState.InProgress]
        );
    }

    public showCashOnDeliveryButton(): boolean {
        return (
            !this.isPaidOnDelivery &&
            this.paymentButtonNeeded &&
            this.task.paymentType === PaymentType.PayOnDeliveryCash &&
            this.task.state === DeliveryTaskState[this.DeliveryTaskState.InProgress]
        );
    }

    getIsPaid(): boolean {
        return this.isPaidOnDelivery || !this.paymentButtonNeeded;
    }

    genereateUniqId(): void {
        this.uniqTransactionIdWithTaskId = `${this.task.deliveryTaskID}|${Math.round(
            +new Date() * 1000
        )}`;
    }

    private checkPayment() {
        this._tasksService
            .isSuccessfulPayment(this.task.deliveryTaskID)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((result) => {
                this.isPaidOnDelivery =
                    result || this.task.cashOnDeliveryFromCustomer > 0;

                if (this.isPaidOnDelivery && !this.sumupPaymentbecameSuccess) {
                    this.sumupFinalization();
                    this.sumupPaymentbecameSuccess = true;
                }
            });
    }

    private sumupFinalization() {
        this.sumUpFinalize = {
            taskID: this.uniqTransactionIdWithTaskId,
            totalAmountFromPayment: this.getTotalPrice(),
        };

        if (this.sumUpFinalize) {
            this._tasksService
                .finalize(this.sumUpFinalize)
                .pipe(take(5))
                .subscribe(
                    () => {
                        this.paymentStatus =
                            'Payment finalization finished (s) - (' +
                            this.datepipe.transform(new Date(), 'yyyy/MM/dd-h:mm:ss') +
                            ')';
                        this.myObservable?.unsubscribe();
                        this.isButtonBlocked = false;
                        this.ngOnDestroy();
                    },
                    (error) => {
                        console.error(error);
                        this.paymentStatus =
                            'Payment finalization finished (e)- (' +
                            this.datepipe.transform(new Date(), 'yyyy/MM/dd-h:mm:ss') +
                            ')';
                        this.myObservable?.unsubscribe();
                        this.isButtonBlocked = false;
                        this.ngOnDestroy();
                    }
                );
        }
    }

    maxChangeValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!this.cashPaymentForm) return null;

            const received = priceRound(
                this.cashPaymentForm.get('amountReceivedFromCustomer')?.value ?? 0
            );

            const payable = priceRound(
                this.cashPaymentForm.get('cashPayableTotal')?.value ?? 0
            );

            const due = priceRound(received - payable);

            if (control.value != null && control.value > due) {
                return { changeTooMuch: true };
            }
            return null;
        };
    }

    onSubmit(): void {
        let infoMessage = this._translateService.instant(
            'messages.cash-on-delivery-info'
        );

        if (confirm(infoMessage) === true) {
            if (this.cashPaymentForm.valid) {
                const cashOnDeliveryAdministration: CashOnDeliveryAdministration = {
                    ...this.cashPaymentForm.getRawValue(), // disabled mezők is benne lesznek
                    taskID: this.task.deliveryTaskID,
                };

                this._tasksService
                    .cashOnDeliveryAdministration(cashOnDeliveryAdministration)
                    .subscribe({
                        next: () => {
                            this.onPayOnDeliveryCashCloseModal(true);
                            this._modalService.setModalVisibility(
                                false,
                                'app-cash-acceptance-modal' + this.task.deliveryTaskID
                            );
                        },
                        error: (err) => {
                            console.error(err);
                        },
                    });
            } else {
                this.cashPaymentForm.markAllAsTouched();
            }
        }
    }

    public closeModal(): void {
        this._modalService.setModalVisibility(
            false,
            'app-cash-acceptance-modal' + this.task.deliveryTaskID
        );
    }

    ngOnDestroy(): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.timerSubscription?.unsubscribe();
        this.componentDestroyed$.next(true);
        this.componentDestroyed$.complete();

        this.detroyedComponent =
            'Ready for navigation - (' +
            this.datepipe.transform(new Date(), 'yyyy/MM/dd-h:mm:ss') +
            ')';
    }

    /**
     * HU készpénzkerekítés különbözet 5 Ft-ra.
     * Eredmény: -2..+2
     */
    private cashRoundingDiffHu(amountFt: number): number {
        const amount = Math.round(amountFt); // Ft egészre
        const r = ((amount % 5) + 5) % 5;

        if (r === 0) return 0;
        return r < 3 ? -r : 5 - r; // 1->-1,2->-2,3->+2,4->+1
    }
}
